import { QuantityType } from '@components/UI-Components/QuantityType/constants/QuantityType'
import { config } from '@config'
import { ASSORTMENT_SOURCE } from '@constants'
import { find, intersection, isEmpty, map, some } from 'lodash'

export const getColumnLabelFromQuantityType = (
  quantityType,
  captureSize,
  isValueSelected
) => {
  return quantityType === QuantityType.Product
    ? `Door ${captureSize ? '/ Sized ' : ''}QTY`
    : `${
        quantityType === QuantityType.Size && captureSize
          ? 'Sized'
          : `${quantityType === QuantityType.DraftWHL ? 'Draft' : 'Door'}`
      } ${isValueSelected ? 'Value' : 'QTY'}`
}

export const getColumnKeyFromQuantityType = (
  quantityType,
  captureSize,
  isValueSelected
) => {
  return quantityType === QuantityType.Product
    ? `door${captureSize ? 'Sized' : ''}QTY`
    : `${
        quantityType === QuantityType.Size && captureSize
          ? 'sized'
          : `${quantityType === QuantityType.DraftWHL ? 'Draft' : 'Door'}`
      }${isValueSelected ? 'Value' : 'QTY'}`
}

export const getDoorQuantityColumnAttributeId = (quantityType, isValueSelected) => {
  return quantityType === QuantityType.Size
    ? isValueSelected
      ? 'totalSizeValue'
      : 'totalSizeQuantity'
    : isValueSelected
    ? 'totalDoorValue'
    : 'totalDoorQuantity'
}

export const getIADoorQuantityColumnAttributeId = quantityType => {
  return quantityType === QuantityType.Size
    ? 'totalDeliverySizeQuantity'
    : 'totalDeliveryDoorQuantity'
}

export const getIADoorAndSizeColumnEnhancedField = quantityType => {
  return quantityType === QuantityType.Size ? 'totalSizeQuantity' : 'totalDoorQuantity'
}

export const isCaptureSizeEnabled = summary => {
  return summary?.client?.captureSize || summary?.clientOrder?.client?.captureSize
}

export const highlightTableColumnDoor = (
  isRetail,
  isBooked,
  doorOrderId,
  doorOrders,
  retailClusterId
) => {
  if (!isRetail) return false
  const { door } = find(doorOrders, doorOrder => doorOrder.id === doorOrderId)
  const isBookedOriginally =
    config.assortmentSource.retail === ASSORTMENT_SOURCE.CLUSTER_GROUP
      ? !isEmpty(
          intersection(
            map(door?.clusterGroup?.clusters, cluster => cluster.id),
            retailClusterId ?? []
          )
        )
      : some(retailClusterId, id => id === door?.cluster.id)
  return (!isBooked && isBookedOriginally) || (isBooked && !isBookedOriginally)
}
